export default "/images/vendor/flag-icon-css/flags/4x3/fr.svg?0c209b8adf548d40535e0236032dfde9";